export default __webpack_public_path__ + "static/media/Cattura7.12704b50.jpg";